export default "__VITE_ASSET__CKJ$bUBZ__"